__turbopack_context__.v({
  "container": "radioField-module-scss-module__dI1L2a__container",
  "label": "radioField-module-scss-module__dI1L2a__label",
  "label-clickable-true": "radioField-module-scss-module__dI1L2a__label-clickable-true",
  "label-disabled-checked-true-true": "radioField-module-scss-module__dI1L2a__label-disabled-checked-true-true",
  "label-disabled-true": "radioField-module-scss-module__dI1L2a__label-disabled-true",
});
